export default [
  { id: "LandingSection", label: "Landing", title: "1Cademy's Landing Page" },
  { id: "HowItWorksSection", label: "How", title: "How We Work?" },
  { id: "ValuesSection", label: "Why", title: "Why 1Cademy?" },
  { id: "CommunitiesSection", label: "What", title: "What we study?" },
  { id: "WhichSection", label: "Which", title: "Which systems?" },
  { id: "SchoolsSection", label: "Where", title: "Where Are We?" },
  { id: "WhoWeAreSection", label: "Who", title: "Who Is Behind 1Cademy?" },
  { id: "JoinUsSection", label: "Apply", title: "Apply to Join Us!" },
];
